import { useEffect, useRef, useState } from "react"

import { useLoader } from "react-three-fiber"
import { TextureLoader } from "three"
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader'
import { isMobile } from "react-device-detect"

export const usePreload = (pages, current, pageStep, disable, skipCurrent) => {
    const [state, setState] = useState([]);
    const [assets, setAssets] = useState([]);

    const getPreloadPages = () => {
        const windowSize = 2 * pageStep;
        const preloadPages = [];
        const preloadIndexes = [];
        const start = Math.max(current - windowSize, 0);
        const end = Math.min(current + windowSize, pages.length);
        for (let i = start; i < end; i++) {
            if (skipCurrent && (i === current || i === current + pageStep - 1) || state.includes(i)) continue;
            preloadPages.push(pages[i]);
            preloadIndexes.push(i);
        }
        setState([...state, ...preloadIndexes]);
        return preloadPages;
    }

    const execPreload = () => {
        if (!pages) return;        
        const preloadPages = getPreloadPages();
        const images = preloadPages.map(({ elements }) => elements.map(({ image }) => image)).flat();
        const keyart = preloadPages.map(({ elements }) => elements.map(({ keyart }) => keyart ? keyart.image : undefined)).flat().filter((item) => item);
        const keyartImages = preloadPages.map(({ elements }) => elements.map(({ elements: sub }) => sub ? sub.map(({ image }) => image) : undefined)).flat(2).filter((item) => item);
        const sticker = preloadPages.map(({ elements }) => elements.map(({ sticker }) => sticker)).flat(2).filter((item) => item);        
        const preload = [...images, ...keyart, ...sticker, ...keyartImages].filter((item) => !assets.includes(item));
        const svg = preloadPages.map(({ elements }) => elements.map(({ svg }) => svg ? svg.url : undefined)).flat().filter((item) => item && !assets.includes(item));
        
        const imagePreload = isMobile ? [] : preloadPages.map(({ thumbnail }) => thumbnail).filter((item) => !assets.includes(item));
        imagePreload.forEach((src) => {
            const img = new Image();
            img.src = src;
        });

        //console.log("preload", preload, imagePreload, svg);
        useLoader.preload(TextureLoader, preload);
        useLoader.preload(SVGLoader, svg);

        setAssets([...assets, ...preload, ...imagePreload, ...svg]);
    }

    const cleanupIntervalRef = useRef();
    useEffect(() => {
        const execCleanup = () => {
            if (!currentTimerRef.current) return;
            console.log ("clean up preloader state");
            setState([]);
            setAssets([])
        }

        cleanupIntervalRef.current = setInterval(execCleanup, 36000000); 
        return () => {
            clearInterval(currentTimerRef.current);
            currentTimerRef.current = null;
        }
    }, [])

    const currentTimerRef = useRef();
    useEffect(() => {
        clearTimeout(currentTimerRef.current);
        if (!pages || disable) return;
        currentTimerRef.current = setTimeout(execPreload, 1000);
        return () => {
            clearTimeout(currentTimerRef.current);
        }
    }, [current, pageStep, pages, disable])
};